import React from 'react';

const TrustSection = ({ themeData }: any) => {
  return (
    <>
      <section className="trust-section">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="split-img">
                <img
                  src={themeData?.theme_3?.home?.section_5?.banner[0]?.banner}
                  alt=""
                />
                <div className="split-img-framegrid">
                  <div className="split-img-frame1"></div>
                  <div className="split-img-frame2"></div>
                  <div className="split-img-frame3"></div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="trust-content">
                <h2
                  style={{
                    color: `#${themeData?.theme_3?.home?.section_5?.h2color}`,
                  }}
                >
                  {themeData?.theme_3?.home?.section_5?.title}
                </h2>
                <p
                  style={{
                    color: `#${themeData?.theme_3?.home?.section_5?.paracolor}`,
                  }}
                >
                  {themeData?.theme_3?.home?.section_5?.paragraph}
                </p>
                <ul>
                  {themeData?.theme_3?.home?.section_5?.check_list &&
                    Object.keys(
                      themeData?.theme_3.home.section_5.check_list
                    ).map((key) => (
                      <li
                        key={key}
                        style={{
                          color: `#${themeData?.theme_3?.home?.section_5?.paracolor}`,
                        }}
                      >
                        {themeData?.theme_3.home.section_5.check_list[key].list}
                      </li>
                    ))}
                </ul>
                <div className="trust-content-btn d-none">
                  <a
                    href="#book-now"
                    className="btn title-btn hover-btn"
                    style={{
                      background: `#${themeData?.theme_3?.home?.section_5?.btn_group?.btn1?.bg_color}`,
                      color: `#${themeData?.theme_3?.home?.section_5?.btn_group?.btn1?.color}`,
                    }}
                  >
                    {themeData?.theme_3?.home?.section_5?.btn_group.btn1.text}
                    <i className="uil uil-arrow-circle-right ms-2"></i>
                  </a>
                  {/* <a
                    href="#book-now"
                    className="btn primary-btn hover-btn"
                    style={{
                      background: `#${themeData?.theme_3?.home?.section_5?.btn_group?.btn2?.bg_color}`,
                      color: `#${themeData?.theme_3?.home?.section_5?.btn_group?.btn2?.color}`,
                    }}
                  >
                    {themeData?.theme_3?.home?.section_5?.btn_group.btn2.text}
                    <i className="uil uil-arrow-circle-right ms-2"></i>
                  </a> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TrustSection;
